/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import { useState } from "react";

import styled from "styled-components";

interface Props {
  tag: string;
  removeTag: (tag: string) => void;
  editable: boolean;
}

export function ViennaTag({ tag, removeTag, editable }: Props) {
  const [hovering, setHovering] = useState(false);

  return (
    <StyledViennaTag onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
      {tag}
      {hovering && editable && (
        <StyledDeleteButton onClick={() => removeTag(tag)}>
          <DeleteIcon />
        </StyledDeleteButton>
      )}
    </StyledViennaTag>
  );
}

const StyledViennaTag = styled.span`
  user-select: none;
  white-space: normal;
  cursor: default;
  color: ${({ theme }) => theme.text.highContrast};
  background-color: ${({ theme }) => theme.primary};
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 11px;
  line-height: 14px;
  margin-right: 5px;
  margin-bottom: 5px;
  position: relative;
  max-width: 125px;
  overflow-wrap: break-word;
`;

const StyledDeleteButton = styled.button`
  width: 13px;
  height: 13px;
  background-color: ${({ theme }) => theme.background};
  position: absolute;
  top: -6px;
  right: -6px;
  cursor: pointer;
  border: ${({ theme }) => `1px solid ${theme.primary}`};
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${({ theme }) => theme.button.hover};
  }
  &:active {
    background-color: ${({ theme }) => theme.button.active};
  }
`;

const DeleteIcon = styled.div`
  height: 1px;
  width: 7px;
  background-color: ${({ theme }) => theme.primary};
`;
